import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { SitesMetadataFormType } from "../types/SitesMetadataFormType.ts";
import { Control, Controller, useFieldArray } from "react-hook-form";
import { TextField } from "@mui/material";

type SitesMetadataTableProps = {
  control: Control<SitesMetadataFormType>;
};

export const SitesMetadataTable = ({ control }: SitesMetadataTableProps) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "sites",
  });

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Zipcode</TableCell>
            <TableCell align="right">Growth/year (%)</TableCell>
            <TableCell align="right">Remove?</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((item, index) => (
            <TableRow
              key={item.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Controller
                  name={`sites.${index}.name`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id={`sites.${index}.name`}
                      label="Name"
                      {...field}
                    />
                  )}
                />
              </TableCell>
              <TableCell align="right">
                <Controller
                  name={`sites.${index}.zipcode`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id={`sites.${index}.zipcode`}
                      label="Zipcode"
                      {...field}
                    />
                  )}
                />
              </TableCell>
              <TableCell align="right">
                <Controller
                  name={`sites.${index}.growthPercentPerYear`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      id={`sites.${index}.growthPercentPerYear`}
                      label="Growth/year (%)"
                      {...field}
                    />
                  )}
                />
              </TableCell>
              <TableCell align={"right"}>
                <button type="button" onClick={() => remove(index)}>
                  X
                </button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <button
        type="button"
        onClick={() =>
          append({ name: "", zipcode: "", growthPercentPerYear: 0 })
        }
      >
        Add site
      </button>
    </TableContainer>
  );
};
